import axios from "axios";
import { MyConst } from "data/MyConst";

const api = axios.create({
  baseURL: MyConst.URLAPI,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    "Access-Control-Allow-Origin": "*",
  },
});

export default api;
